import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { availableBrands } from '../../Containers/CustomRandy/CustomRandy.types';
import { AgenciesService, BrandDto } from '../../Services/API';

export const useGetBrandCodes = (config?: UseQueryOptions<BrandDto, Error>) => {
  return useQuery<BrandDto, Error>(
    [],
    async () => {
      return await AgenciesService.agenciesControllerGetBrandsAvailable();
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      ...config,
    }
  );
};

export function isFromAMOnly(brands: BrandDto | undefined): boolean {
  if (!brands) return false;
  return brands.brands.every(brand => availableBrands.has(brand));
}
